import { AxiosResponse } from 'axios';

import apiClient from '../client';
import { ApiResponseDto } from 'interfaces/apiResponse';
import { CompanyContactDto, LinkCompanyContactDto } from 'interfaces/companies/contact';

interface CompanyContactService {
  getContacts(companyId: string): Promise<CompanyContactDto[]>;
  linkContact(companyId: string, id: string, postData: LinkCompanyContactDto): Promise<void>;
  unlinkContact(companyId: string, id: string): Promise<void>;
}

const endpoints = {
  getContacts: (companyId: string) => `/companies/${companyId}/contact-persons`,
  linkContact: (companyId: string, id: string) => `/companies/${companyId}/contact-persons/${id}`,
  unlinkContact: (companyId: string, id: string) => `/companies/${companyId}/contact-persons/${id}`,
};

export const companyContactService: CompanyContactService = {
  getContacts: async (companyId: string): Promise<CompanyContactDto[]> => {
    const response: AxiosResponse<ApiResponseDto<CompanyContactDto[]>> = await apiClient.get(endpoints.getContacts(companyId));

    if (response.data.errors) {
      throw new Error(response.data.errors!.map(error => error.message).join(', '));
    }

    return response.data.data!;
  },
  linkContact: async (companyId: string, id: string, postData: LinkCompanyContactDto): Promise<void> => {
    const response: AxiosResponse<ApiResponseDto<void>> = await apiClient.put(endpoints.linkContact(companyId, id), postData);

    if (response.data.errors) {
      throw new Error(response.data.errors!.map(error => error.message).join(', '));
    }
  },
  unlinkContact: async (companyId: string, id: string): Promise<void> => {
    const response: AxiosResponse<ApiResponseDto<void>> = await apiClient.delete(endpoints.unlinkContact(companyId, id));

    if (response.data.errors) {
      throw new Error(response.data.errors!.map(error => error.message).join(', '));
    }
  },
};
